const actions = {
  resetQuiz({ dispatch, commit, getters, rootGetters }, categoryId) {
    commit('categoryStates/deleteCategoryStates', categoryId, { root: true });
    commit('flashcardStates/deleteFlashcardStates', { type: 'Category', categoryId }, { root: true });
    return rootGetters['session/ajax'].post('/quizzes/reset', {category_id: categoryId}).then(response => {
      return response;
    });
  },
  async createUserQuiz({ dispatch, commit, getters, rootGetters }, params) {
    const response = await rootGetters['session/ajax'].post('/user_quizzes', params);
    await dispatch('session/loadUser', null, { root: true });

    if (response.data.records) {
      commit('categories/setCategories', response.data.records, { root: true });
      return response.data.records[0];
    } else {
      commit('categories/setCategories', response.data.categories, { root: true });
      return response.data.categories[0];
    }
  },
  deleteQuiz({ dispatch, commit, getters, rootGetters }, categoryId) {
    return rootGetters['session/ajax'].delete(`/user_quizzes/${categoryId}`).then(response => {
      commit('categories/deleteCategory', categoryId, { root: true });
      commit('categoryStates/deleteCategoryStates', categoryId, { root: true });
      commit('flashcardStates/deleteFlashcardStates', { type: 'Category', categoryId }, { root: true });
      return response;
    });
  },
};

export default {
  namespaced: true,
  actions,
};
